import { common } from '@ocean/ui'
import { ReferenceRecord } from '../../types'
import { Wrapper, ReferenceItem } from './ReferenceList.styled'

const { Typography } = common

type ReferenceListProps = {
  refs: ReferenceRecord[]
}

const ReferenceList: React.FC<ReferenceListProps> = ({ refs }) => {
  if (!refs.length) return null

  return (
    <Wrapper data-test='ReferenceList'>
      {refs.map(({ title, color, pattern }) => (
        <ReferenceItem key={color} color={color} $pattern={pattern}>
          <Typography variant='small'>{title}</Typography>
        </ReferenceItem>
      ))}
    </Wrapper>
  )
}

export default ReferenceList
